import { Controller } from "react-hook-form";
import { Input } from "../../../../../components/Input";
import React, {FC} from "react";
import {TextArea} from "../../../../../components/TextArea";
import {ENTRANCES_VALUE} from "../../const";

interface Props {
  control: any;
}

const EntranceFields: FC<Props> = ({control}) => {

  return (
    <>
      <Controller
        render={({ field, fieldState }) => {
          return (
            <Input
              placeholder="Желаемые адреса (город, улица, дом)"
              {...field}
              {...fieldState}
              ref={null}
            />
          );
        }}
        name={`${ENTRANCES_VALUE}.address`}
        control={control}
      />
      <Controller
        render={({ field, fieldState }) => {
          return (
            <TextArea
              placeholder="Комментарий"
              {...field}
              {...fieldState}
              ref={null}
            />
          );
        }}
        name={`${ENTRANCES_VALUE}.comment`}
        control={control}
      />
    </>
  );
};

export default EntranceFields;
